import React from "react";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import SendToApp from "web/react/components/send-to-app/send-to-app";
import LeadLink from "web/react/components/lead-link/lead-link";
import styles from "./send-to-app-with-tracked-link.css";
export default function SendToAppWithTrackedLink(_ref) {
  var title = _ref.title,
      analyticsEventLabel = _ref.analyticsEventLabel,
      url = _ref.url,
      productImageURL = _ref.productImageURL,
      appDeepLinkURL = _ref.appDeepLinkURL,
      className = _ref.className,
      leadUrl = _ref.leadUrl,
      productId = _ref.productId,
      reason = _ref.reason,
      financialIncentiveWebviewToken = _ref.financialIncentiveWebviewToken,
      downloadCTA = _ref.downloadCTA;

  function beforeLeadLinkClicked(callbackFunction, event) {
    analytics.event("send_to_app", "lead_clicked", analyticsEventLabel);
    callbackFunction(event);
  }

  downloadCTA = downloadCTA ? downloadCTA : gettext("app_download_large_banner.general.cta");
  return React.createElement(SendToApp, {
    title: title,
    analyticsEventLabel: analyticsEventLabel,
    url: url,
    productImageURL: productImageURL,
    downloadCTA: downloadCTA,
    className: className,
    appDeepLinkURL: appDeepLinkURL,
    financialIncentiveWebviewToken: financialIncentiveWebviewToken,
    extraContent: function extraContent() {
      return React.createElement(React.Fragment, null, React.createElement("div", {
        className: styles.orContainer
      }, React.createElement("span", {
        className: styles.or
      }, gettext("in_stock_product.or_separator"))), React.createElement(LeadLink, {
        href: leadUrl,
        openInNewTab: true,
        productId: productId,
        reason: reason,
        beforeOnClick: beforeLeadLinkClicked
      }, React.createElement("span", {
        className: styles.continueOnRetailer
      }, gettext("general.continue_to_retailer.link"))));
    }
  });
}